<img 
*ngIf="event" 
[routerLink]="'/events/detail/'+event.id" id="{{event.id}}" 
class="h-64 w-64 rounded-lg object-cover md:h-72 md:w-72 shadow-xl cursor-pointer" 
src="{{event.profile_photo?.thumbnail_path ? event.profile_photo?.thumbnail_path : event.header_photo?.thumbnail_path ? event.header_photo?.thumbnail_path : '/assets/s3/01.jpg'}}" 
alt=""
/>